<mat-accordion  style="z-index: 999; box-shadow: 0 1px 16px 0 rgba(0, 0, 0, .5), 0 4px 8px 0 rgba(0, 0, 0, .28), 0 8px 8px -1px rgba(0, 0, 0, .24);">
  <span *ngFor="let child of myMenus" >
  <mat-expansion-panel #mainPanel  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div>
          <button  mat-button style="padding: 0px"><img style="height: 25px; width: 30px; " [src]="child.iconName" ></button>{{child.displayName}}
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <span *ngFor="let children of child.children" >
          <mat-card style="background-color: rgba(26,47,75,0.7)" >
            <div >
            <button mat-button style="padding: 0px" (click)="hideMenus()" style="width: 100%; color: white; text-align: left; font-size: 17px;text-shadow:2px 2px 2px black;"  [routerLink]="children.route"><img style="height: 20px; width: 20px; padding-right: 10px; " src="assets/menu.png" >{{children.displayName}}</button>
            </div>
          </mat-card>
    </span>
  </mat-expansion-panel>
  </span>
  <span *ngIf="myMenus.length>0" >
  <mat-expansion-panel hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <p  (click)="hideMenus()" routerLink="reports">
          <button mat-button > <img style="height: 25px; width: 30px; "  src="assets/print-24px.svg" ></button>Reports
        </p>
      </mat-panel-title>
    </mat-expansion-panel-header>
  </mat-expansion-panel>
  </span>
</mat-accordion>
<!--
  </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div>
          <button mat-button><img src="assets/payment-24px.svg" ></button>
          Payment
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div (click)="getMenu('Container Charges')" [routerLink]="">+ Container Charges</div>
      <div (click)="getMenu('Import Charges Calculator')" >+ Import Charges Calculator</div>

    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div>
            <button mat-button><img style="height: 25px; width: 30px; " src="assets/cargo_container.png" ></button>
            Equipment
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div><p>+ Inquiry screen</p></div>
    </mat-expansion-panel>

</mat-accordion>
-->
